// TODO - localise output
export var buildDefaultAriaLabelForProgress = function buildDefaultAriaLabelForProgress(progress) {
  return "".concat((progress * 100).toFixed(0), "%");
};